import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { EnvironmentService } from '@pedix-workspace/angular-utils';
import { CDN_URL } from '@pedix-workspace/utils';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'uriStorage',
  standalone: true,
})
export class UriStoragePipe implements PipeTransform {
  private environmentService = inject(EnvironmentService);

  transform(uri?: string): string {
    if (!uri) {
      return '';
    }

    const searchParams = new URLSearchParams();

    if (this.environmentService.env === 'development') {
      searchParams.append('env', this.environmentService.env);
    }

    return `${CDN_URL}/${uri}?${searchParams.toString()}`;
  }
}
